/**
 *  Author : Ravi Kumar Gupta
 *  Reference : https://github.com/arasatasaygin/is.js/blob/master/is.js
 *  @func isObject, isArray, isDate, isJson, isEmpty, isArgument
 */

var toString = Object.prototype.toString;
var slice = Array.prototype.slice;

function getParams(args) {
    var params = slice.call(args);
    var length = params.length;
    if (length === 1 && isArray(params[0])) {
        // support array
        params = params[0];
    }
    return params;
}

function not(func) {
    return function() {
        return !func.apply(null, slice.call(arguments));
    };
}

function all(func) {
    return function() {
        var params = getParams(arguments);
        var length = params.length;
        for (var i = 0; i < length; i++) {
            if (!func.call(null, params[i])) {
                return false;
            }
        }
        return true;
    };
}

function any(func) {
    return function() {
        var params = getParams(arguments);
        var length = params.length;
        for (var i = 0; i < length; i++) {
            if (func.call(null, params[i])) {
                return true;
            }
        }
        return false;
    };
}

// Type checks
/* -------------------------------------------------------------------------- */

// is a given value object? i.e Array, Date, Math, {} (Object literal)
export const isObject = value => {
    return Object(value) === value;
};

// start : can create other type checks using not, all, any
export const isNotObject = not(isObject);

export const isAllObject = all(isObject);

export const isAnyObject = any(isObject);
// end

export const isArray =
    Array.isArray ||
    function(value) {
        // check native isArray first
        return toString.call(value) === "[object Array]";
    };

export const isDate = value => {
    return toString.call(value) === "[object Date]";
};

export const isJson = value => {
    return (
        toString.call(value) === "[object Object]" ||
        (value != null && typeof value === "object" && !isArray(value))
    );
};

export const isArgument = value => {
    // fallback check is for IE
    return (
        toString.call(value) === "[object Arguments]" ||
        (value != null && typeof value === "object" && "callee" in value)
    );
};

// is a given value thenable (like Promise)?
export const isThenable = value => {
    return isObject(value) && typeof value.then === "function";
};

// Presence checks
/* -------------------------------------------------------------------------- */

//is a given value empty? Objects, arrays, strings
export const isEmpty = value => {
    if (isObject(value)) {
        var length = Object.getOwnPropertyNames(value).length;
        if (
            length === 0 ||
            (length === 1 && isArray(value)) ||
            (length === 2 && isArgument(value))
        ) {
            return true;
        }
        return false;
    }
    return value === "";
};

export const isNotEmpty = not(isEmpty);

export const isValidMail = value => {
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRegex.test(value)) return true;
    return false;
};

export const isValidMobile = value => {
    const mobieRegex = /^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$/;
    if (mobieRegex.test(value)) return true;
    return false;
};
